import React, { Component } from "react";
import PropTypes from "prop-types";

class ReportLink extends Component {
  constructor(props) {
    super(props);
    this.download = this.download.bind(this);
  }

  download() {
    const { clickHandler, reportId, filename } = this.props;
    clickHandler(reportId, filename);
  }

  render() {
    return (
      <div
        title={this.props.linkText}
        className="clickable reportLink"
        onClick={this.download}
      >
        <i className="fa fa-1 text-primary fa-download" />
      </div>
    );
  }
}

ReportLink.propTypes = {
  clickHandler: PropTypes.func.isRequired,
  reportId: PropTypes.string.isRequired,
  linkText: PropTypes.string.isRequired,
  filename: PropTypes.string.isRequired
};

export default ReportLink;



// WEBPACK FOOTER //
// ./src/reports/ReportLink.js